import { skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchInfluencerRelatedBrandsQuery } from '@/api/influencer-api'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { useFetchRelatedBrandsQuery } from '@/api/workspace-api/kol-api'
import { Duration } from '@/components/common/duration-select'
import { usePermissions } from '@/hooks/use-permissions'
import { RelatedKolType } from '@/store/kol-detail'
import { RelatedKol } from '@/types/api/kols'
import { ListResource } from '@/types/resource-type'
import { PlatformShortcode } from '@/utils/convert-platform'

type UseMentionedBrands = (params: {
  kolId?: string
  kolDcIdHashed?: string
  isKolInfoLocked: boolean
  duration: Duration
  platform: PlatformShortcode
  perPage?: number
}) => {
  mentionedBrands?: ListResource<RelatedKol>
  isFetching: boolean
}

const useMentionedBrands: UseMentionedBrands = ({
  kolId,
  kolDcIdHashed,
  platform,
  duration,
  isKolInfoLocked,
  perPage,
}) => {
  const { withKolPermission } = usePermissions()
  const { data: userStatus, isFetching: isFetchingUserStatus } =
    useFetchUserStatusQuery(withKolPermission ? skipToken : undefined)
  const {
    data: mentionedBrandsByAd,
    isFetching: isFetchingMentionedBrandsByAd,
  } = useFetchRelatedBrandsQuery(
    !withKolPermission &&
      userStatus?.currentWorkspaceId &&
      kolId &&
      !isKolInfoLocked &&
      platform === PlatformShortcode.Instagram
      ? {
          workspaceId: userStatus.currentWorkspaceId,
          radar_uuid: kolId,
          dc_id_hashed: kolDcIdHashed,
          platform,
          kolType: RelatedKolType.Brand,
          scope: duration,
          page: 1,
          perPage,
        }
      : skipToken,
  )

  const {
    data: mentionedBrandsByKol,
    isFetching: isFetchingMentionedBrandsByKol,
  } = useFetchInfluencerRelatedBrandsQuery(
    withKolPermission && kolId && platform === PlatformShortcode.Instagram
      ? {
          radar_uuid: kolId,
          platform,
          kolType: RelatedKolType.Brand,
          scope: duration,
          page: 1,
          perPage,
        }
      : skipToken,
  )

  return {
    mentionedBrands: withKolPermission
      ? mentionedBrandsByKol
      : mentionedBrandsByAd,
    isFetching: withKolPermission
      ? isFetchingMentionedBrandsByKol
      : isFetchingUserStatus || isFetchingMentionedBrandsByAd,
  }
}

export default useMentionedBrands
